import React from 'react';
import { useTranslation } from "react-i18next";

const Echantillon = () => {
  const { t } = useTranslation();
    return (
        <div className="creat-space-class">
            <div data-aos="fade-up" className="creat-space-back echantillon-back">
                <h1>{t("text39b")}</h1>
            </div>

            <div data-aos="fade-up" className="creat-space-info ColorChart-info">
                <h1>{t("text40b")}</h1>
            </div>

            <div className="ColorChart">
                <div className="ColorChart-img"></div>
            </div>

            <div data-aos="fade-up" className="creat-space-info ColorChart-info ColorChart-color">
                <h1>{t("text40c")}</h1>
            </div>

            <div className="list-echan">
                <div className="list-echan-chart">
                    <div className="Chartp1 Chartall">
                        
                    </div>
                    <div className="Chartp2 Chartall">

                    </div>
                    <div className="Chartp3 Chartall">

                    </div>
                    <div data-aos="fade-up" className="home-companywork">
          <div className="home-companywork-img">
            <div className="gallery">
              <img className="img-1a" src="/media/echan/16.png" alt=""></img>
              <img className="img-2a" src="/media/echan/12.png" alt=""></img>
              <img className="img-3a" src="/media/echan/13.png" alt=""></img>
              <img className="img-4a" src="/media/echan/14.png" alt=""></img>
              <img className="img-5a" src="/media/echan/15.png" alt=""></img>
              <img className="img-6a" src="/media/echan/45.png" alt=""></img>
              <img className="img-7a" src="/media/echan/17.png" alt=""></img>
              <img className="img-8a" src="/media/echan/18.png" alt=""></img>
              <img className="img-9a" src="/media/echan/19.png" alt=""></img>
              <img className="img-10a" src="/media/echan/20.png" alt=""></img>
              <img className="img-11a" src="/media/echan/21.png" alt=""></img>
              <img className="img-12a" src="/media/echan/22.png" alt=""></img>
              <img className="img-13a" src="/media/echan/23.png" alt=""></img>
              <img className="img-14a" src="/media/echan/24.png" alt=""></img>
              <img className="img-15a" src="/media/echan/25.png" alt=""></img>
              <img className="img-16a" src="/media/echan/26.png" alt=""></img>
              <img className="img-17a" src="/media/echan/27.png" alt=""></img>
              <img className="img-18a" src="/media/echan/28.png" alt=""></img>
              <img className="img-19a" src="/media/echan/29.png" alt=""></img>
              <img className="img-20a" src="/media/echan/30.png" alt=""></img>
              <img className="img-21a" src="/media/echan/31.png" alt=""></img>
              <img className="img-22a" src="/media/echan/32.png" alt=""></img>
              <img className="img-23a" src="/media/echan/33.png" alt=""></img>
              <img className="img-24a" src="/media/echan/34.png" alt=""></img>
              <img className="img-25a" src="/media/echan/35.png" alt=""></img>
              <img className="img-26a" src="/media/echan/36.png" alt=""></img>
              <img className="img-27a" src="/media/echan/37.png" alt=""></img>
              <img className="img-28a" src="/media/echan/38.png" alt=""></img>
              <img className="img-28a" src="/media/echan/39.png" alt=""></img>
              <img className="img-28a" src="/media/echan/40.png" alt=""></img>
              <img className="img-28a" src="/media/echan/41.png" alt=""></img>
              <img className="img-28a" src="/media/echan/42.png" alt=""></img>
              <img className="img-28a" src="/media/echan/43.png" alt=""></img>
              <img className="img-28a" src="/media/echan/44.png" alt=""></img>
              <img className="img-28a" src="/media/echan/11.png" alt=""></img>
              <img className="img-28a" src="/media/echan/46.png" alt=""></img>
              <img className="img-28a" src="/media/echan/47.png" alt=""></img>
              <img className="img-28a" src="/media/echan/48.png" alt=""></img>
            </div>
          </div>
        </div>
                </div>
            </div>
        </div>
    );
  }
  export default Echantillon;